import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './FeatureRequestsAdminView.css';

function FeatureRequestsAdminView({ onNavigate, onBack }) {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Feature Requests Admin - Wixon & Cross Desk Suite';
  }, []);

  return (
    <div className="admin-view">
      <header className="admin-view-header">
        <div className="admin-view-header-content">
          <div className="breadcrumb-nav-app">
            <button className="breadcrumb-item" onClick={() => navigate('/desktop')}>
              🖥️ Desktop
            </button>
            <span className="breadcrumb-separator">›</span>
            <button className="breadcrumb-item" onClick={() => navigate('/dashboard')}>
              📦 Dashboard
            </button>
            <span className="breadcrumb-separator">›</span>
            <button className="breadcrumb-item" onClick={onBack}>
              💡 Feature Requests
            </button>
            <span className="breadcrumb-separator">›</span>
            <span className="breadcrumb-item breadcrumb-current">⚙️ Admin</span>
          </div>
          <button className="btn btn-secondary btn-small" onClick={onBack}>
            ← Back to Features
          </button>
        </div>
      </header>

      <main className="admin-view-main">
        <h1 className="admin-view-title">Admin Panel</h1>
        <p className="admin-view-subtitle">Manage users, applications, and system settings</p>
        
        <div className="admin-cards-grid">
          <div className="admin-card" onClick={() => onNavigate('users')}>
            <div className="admin-card-icon">👥</div>
            <h3>Manage Users</h3>
            <p>Assign roles, manage permissions, and control user access</p>
            <button className="btn btn-primary">Open</button>
          </div>

          <div className="admin-card" onClick={() => onNavigate('apps')}>
            <div className="admin-card-icon">📱</div>
            <h3>Manage Applications</h3>
            <p>Add, edit, and organize application names</p>
            <button className="btn btn-primary">Open</button>
          </div>

          <div className="admin-card admin-card--disabled">
            <div className="admin-card-icon">⚙️</div>
            <h3>System Settings</h3>
            <p>Configure notifications, workflows, and system preferences</p>
            <span className="coming-soon-badge">Coming Soon</span>
          </div>

          <div className="admin-card admin-card--disabled">
            <div className="admin-card-icon">📊</div>
            <h3>Reports & Analytics</h3>
            <p>View request trends, voting patterns, and user activity</p>
            <span className="coming-soon-badge">Coming Soon</span>
          </div>
        </div>
      </main>
    </div>
  );
}

export default FeatureRequestsAdminView;
